import { Controller } from "@hotwired/stimulus";

// A wall clock for one IANA time zone, ticking from the visitor's own device:
//
//   <div data-controller="clock" data-clock-time-zone-value="Europe/Oslo">
//     <p data-clock-target="time">21:04</p>
//     <p data-clock-target="date">13 Temmuz 2026 Pazartesi</p>
//     <p data-clock-target="offset">UTC+02:00</p>
//   </div>
//
// The server renders the same three values, so the clock is already right without
// JavaScript — and stays right afterwards, since a cached or long-open page would
// otherwise freeze at whatever time it was rendered.
export default class extends Controller {
  static targets = ["time", "date", "offset"];
  static values = { timeZone: String };

  connect() {
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  tick() {
    const now = new Date();
    const timeZone = this.timeZoneValue;

    this.timeTarget.textContent = this.#format(now, {
      timeZone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    if (this.hasDateTarget) {
      this.dateTarget.textContent = this.#format(now, {
        timeZone,
        day: "numeric",
        month: "long",
        year: "numeric",
        weekday: "long",
      });
    }

    if (this.hasOffsetTarget) {
      const parts = new Intl.DateTimeFormat("tr-TR", {
        timeZone,
        timeZoneName: "longOffset",
      }).formatToParts(now);
      // "GMT+02:00" — and plain "GMT" on the zones sitting at UTC.
      this.offsetTarget.textContent = parts
        .find((part) => part.type === "timeZoneName")
        .value.replace("GMT", "UTC");
    }
  }

  #format(date, options) {
    return new Intl.DateTimeFormat("tr-TR", options).format(date);
  }
}
